const initialState = {
    detailproduct: {
        caracteristicas: [],
        categoriaBeneficio: "",
        estado: "",
        etiquetas: [],
        icono: "",
        idProducto: null,
        idProoveedor: null,
        tipoBeneficio: "",
        tipoCategoria: "",
        tipoServicio: "",
        urlPagina: "",
        countryCode: [],
        //countryPhoneCodeId: 1,
        //valorUnitarioCliente: 0,
    }
};

const state = {
    detailproduct: { ...initialState.detailproduct },
    loading: false,
    products: [],
    productsClient: [],
    product_by_mode: null,
    countryCode: [],
};

export { state, initialState };